import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const handle: SEOHandle = {
	getSitemapEntries: () => [{ route: '/tree-planting' }],
}
export const meta: MetaFunction = () => [
	{ title: 'How tree planting works | Erda' },
	{
		name: 'description',
		content:
			'Understand how Erda place sponsorships fund trees, what renewals support and how community tree totals are calculated.',
	},
	{ property: 'og:title', content: 'How tree planting works | Erda' },
	{
		property: 'og:description',
		content:
			'Understand how Erda place sponsorships fund trees, what renewals support and how community tree totals are calculated.',
	},
	{ property: 'og:url', content: 'https://erda.app/tree-planting' },
]
export default function Page() {
	return (
		<article className="panel-copy">
			<h1>Tree support, clearly explained.</h1>
			<p>A small place on the map helps support tree planting beyond it.</p>
			<section>
				<h2>Your free place</h2>
				<p>
					Your first place is free and does not fund trees. After claiming, you
					can choose a one-off $2 payment to help fund two trees with Trees for
					the Future. This is optional and doesn’t affect your ownership.
				</p>
				<p>
					We confirm the charity contribution before adding it to your tree
					total and sending your impact email. No subscription is created.
				</p>
				<a
					href="https://trees.org/?form=FUNRTALHRNR"
					target="_blank"
					rel="noreferrer"
				>
					Or donate directly on the charity’s website
				</a>
			</section>
			<section>
				<h2>Two trees with every paid place</h2>
				<p>
					Additional places and gifts cost $2 per place per year. Erda’s model
					funds two trees with the initial purchase and two more with each
					annual renewal.
				</p>
				<p>
					Of each $2 payment, $0.70 goes to Trees for the Future through Pledge.
					The remainder supports Erda and payment costs. Your payment covers
					your digital sponsorship and its tree contribution; it is not a direct
					donation of the full purchase price to the planting organisation.
				</p>
			</section>
			<section>
				<h2>Our planting partner</h2>
				<p>
					Erda supports tree planting through Trees for the Future. The place
					you choose on the map is personal to you; trees are not planted at
					those coordinates.
				</p>
				<a href="https://trees.org/" target="_blank" rel="noreferrer">
					Visit Trees for the Future
				</a>
			</section>
			<section>
				<h2>What the tree total means</h2>
				<p>
					Community totals estimate trees funded from recorded donations and the
					applicable cost per tree. They do not track individual trees, their
					survival or carbon removed.
				</p>
				<Link to="/leaderboard">View community impact</Link>
			</section>
			<section>
				<h2>Your digital place</h2>
				<p>
					A sponsorship does not give you physical land, ownership of a tree or
					carbon credits. You can manage annual renewals from your account.
				</p>
				<nav>
					<Link to="/own-something-unique">Sponsor a place</Link>
					<Link to="/digital-gift">Give a place</Link>
					<Link to="/contact">Ask about tree funding</Link>
				</nav>
			</section>
		</article>
	)
}
